import { BaseEntity, BaseResponse } from '../entities/BaseEntities';
import CustomStore from 'devextreme/data/custom_store';
import { BaseEndpointCRUD } from '../endpoint/BaseEndpointCRUD';
import { BaseDataStoreAbstract } from './BaseDataStoreAbstract';
import { DataLoadOptions } from './DataLoadOptions';
import { map } from "rxjs/operators";
import { AppInjector } from '@core/injector/injector.module';
import { FrameworkService } from '@core/framework/framework.service';
import {UiService} from '@core/framework/ui.service';

export class BaseDataStoreCRUDServer<TEntity extends BaseEntity> extends BaseDataStoreAbstract
{

    // @ts-ignore
    constructor(private endpoint: BaseEndpointCRUD<TEntity>, private isRaw: boolean = true, private customLoadAction?: (options?: DataLoadOptions) => Observable<any>)
    {
        //Call base
        super();

        this.m_store = new CustomStore({
            key: "EntryID",
            loadMode: isRaw ? "raw": "processed",
            load: (loadOptions) => this.ImplementLoad(loadOptions),
            byKey: (Value) => this.ImplementByKey(Value),
            update: (key, entity) => this.ImplementUpdate(key, entity),
            remove: (key) => this.ImplementRemove(key),
            insert: (entity) => this.ImplementInsert(entity)
        });
    }

    private ImplementLoad(loadOptions): Promise<any> {
        //Prepare options object
        var options = new DataLoadOptions(loadOptions);

        if (this.customLoadAction == undefined) {
            return this.ShapeResponse(this.endpoint.GetList(options));
        }
        else {
            return this.ShapeResponse(this.customLoadAction(options));
        }
    }

    //Get data by key
    private ImplementByKey(Value: any): Promise<any>
    {
        return this.ShapeResponse(this.endpoint.Get(Value));
    }

    private ImplementInsert(entity: TEntity)
    {
        return this.ShapeResponse(this.endpoint.Save(entity));
    }

    private ImplementUpdate(key: number, newEntity: TEntity): Promise<any>
    {
        let data = <Array<BaseEntity>>(<any>this.Store).__rawData;
        if (data) {
            const oldEntity = data.filter(r => r.EntryID === key)[0];
            const entity = { ...oldEntity, ...newEntity };
            return this.ShapeResponse(this.endpoint.Save(entity));
        }

        return this.Store.byKey(key).then((value) => {
            const oldEntity = value;
            const entity = { ...oldEntity, ...newEntity };
            return this.ShapeResponse(this.endpoint.Save(entity));
        });
    }

    private ImplementRemove(entryID: number): Promise<any>
    {
        return this.endpoint.Delete(entryID).pipe(
            map((resultObject: any) =>
            {
                //Make sure result is success
                if (!(resultObject as BaseResponse).IsSuccess)
                {
                    AppInjector.get(UiService).StopMessage((resultObject as BaseResponse).ResponseMessage);
                    return false;
                }
            })).toPromise();
    }
}
